import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import Header from "@/components/Header";
import AppIcon from "@/components/AppIcon";
import LoadError from "@/components/LoadError";
import { apiErrorMessage } from "@/lib/apiResponses";

export default function CollectionsView() {
  const navigate = useNavigate();
  const [cols, setCols] = useState(null);
  const [error, setError] = useState(null);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    const controller = new AbortController();
    setCols(null);
    setError(null);
    api.collections({ signal: controller.signal })
      .then((data) => { if (!controller.signal.aborted) setCols(data); })
      .catch((e) => { if (!controller.signal.aborted) setError(apiErrorMessage(e)); });
    return () => controller.abort();
  }, [retry]);

  return (
    <div className="ambient pb-28">
      <Header title="Подборки" subtitle="Тематические коллекции приложений" />
      <div className="relative z-10 px-4 pt-4 space-y-8">
        {error ? <LoadError message={error} onRetry={() => setRetry((n) => n + 1)} testId="collections-error" /> : cols === null ? (
          <div className="py-10 text-center text-slate-500" role="status">Загрузка…</div>
        ) : cols.length === 0 ? (
          <div className="py-10 text-center text-slate-500">Подборок пока нет.</div>
        ) : cols.map((col) => (
          <section key={col.id} data-testid={`collection-${col.id}`}>
            <h2 className="font-display text-xl font-bold">{col.title}</h2>
            {col.subtitle && <p className="text-xs text-slate-400 mb-3">{col.subtitle}</p>}
            <div className="grid grid-cols-4 gap-3">
              {(col.apps || []).map((app) => (
                <div
                  key={app.id}
                  onClick={() => navigate(`/app/${app.id}`)}
                  className="cursor-pointer active:opacity-70 transition"
                >
                  <AppIcon src={app.icon} alt={app.name} size={72} className="rounded-2xl border border-white/10 w-full" />
                  <div className="mt-1 text-[11px] font-medium text-center truncate">{app.name}</div>
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
